import React from 'react';
import styles from './EmailMessage.module.scss';
const EmailMessage = ({ message }) => {
    return (React.createElement("div", { className: styles.messageContainer }, message.subject && React.createElement("div", { className: styles.subjectContainer }, message.subject)));
};
export default EmailMessage;
